module.exports = __webpack_public_path__ + "img/activity_6_image.ce19c49e.jpg";